import { useFormContext, Controller } from 'react-hook-form';
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import { IWorkflow } from './models/workflow';

interface IProps {
    errorMessage: string
}

const SendCode = (props: IProps) => {
    const { control, formState: { errors } } = useFormContext<IWorkflow>();

    return (
        <>
            <div className='verify-card-header'>
                <span className='step'>Step 1 of 3</span>
                <h4>Verify Your Email</h4>
            </div>
            <div className='verify-card-body'>
                {props.errorMessage && (
                    <div className='error-notice'>{props.errorMessage}</div>
                )}

                <p>To verify your account, enter the email address this link was sent to. We'll email you a confirmation code.</p>

                <FormGroup validationState={errors.emailAddress != null ? 'error' : null}>
                    <ControlLabel>Email address</ControlLabel>

                    <Controller
                        control={control}
                        name='emailAddress'
                        rules={{
                            validate: (value) => {
                                if (value.trim() == '') {
                                    return 'Email address is required';
                                }

                                if (Utility.isValidEmail(value.trim()) == false) {
                                    return 'Email address is not in a valid format';
                                }
                            }
                        }}
                        render={({ field: { onChange, value } }) => (
                            <FormControl type='email' value={value} onChange={onChange} />
                        )}
                    />

                    {errors.emailAddress != null && (
                        <HelpBlock>{errors.emailAddress.message}</HelpBlock>
                    )}
                </FormGroup>
            </div>
            <div className='verify-card-footer'>
                <Button type='submit' bsStyle='primary'>Send Code</Button>
            </div>
        </>
    );
}

export default SendCode;
